var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardhat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.48,69.56c16.36,6.45,34.94,15.93,37.89,52.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.35,121.92s2.28-39,38-52.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "63.33 122.2 35.07 122.2 35.07 149.82 180.59 149.82 180.59 122.36 153.53 122.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.19 78.19 83.17 57.11 134.29 57.11 128.27 78.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardhat);
export default __webpack_public_path__ + "static/media/HARDHAT.098bd69dae239c811a903f1c11b099d4.svg";
export { ForwardRef as ReactComponent };